<template>
	<CustomSelectComponent @input="handleInput" :value="value" add-class="mb-3" :options="directionOptions" placeholder="Estimasi arah dari titik pantau" />
</template>

<script>
import {getDirection} from "../../service/LocationService";
import CustomSelectComponent from "./CustomSelectComponent";
import {mapState, mapMutations} from "vuex"

export default {
	name: "SelectDirectionComponent",
	components: {CustomSelectComponent},
  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },
	async mounted() {
		if (this.directions.length) {
			this.directionOptions = this.directions
		} else {
			let res = await getDirection({})
			this.directionOptions = res.data
			this.setDirections(res.data)
		}
	},
	data() {
		return {
			directionOptions: []
		}
	},
	computed: {
		...mapState('LocationStore', ['directions'])
	},
	methods: {
		...mapMutations('LocationStore', ['setDirections']),
    handleInput(e) {
      this.$emit('input', this.directionOptions.find(item => {
        return String(item.id) === String(e)
      }))
    }
	},
}
</script>

<style scoped>

</style>
